import { subscriptionHandler } from '../resources/accountSubscriptionResource';
import assetSubscriptionResource from '../resources/AssetSubscriptionResource';
import autosuggestHEREResource from '../resources/autosuggestHEREResource';
import chargingStationAutocomplete from '../resources/chargingStationAutocomplete';
import chargingStationByIdResource from '../resources/chargingStationById';
import { chargingStationsMetadataResource } from '../resources/chargingStationListMetadata';
import { featureTogglesAllActive } from '../resources/featureTogglesResource';
import { calculateItinerariesResource, selectItinerariesResource } from '../resources/itinerariesResource';
import operatorsListResource from '../resources/operatorsListResource';
import revgeocodeHEREResource from '../resources/revgeocodeHEREResource';
import { sendToOptimizerResponse } from '../resources/sendToOptimizerResource';
import { sendToVehicleResponse } from '../resources/sendToVehicleResource';
import { TourIsolineResponse } from '../resources/tourIsolineResource';
import { GetToursHandler } from '../resources/toursListResource';
import { CreateTourHandler, UpdateTourHandler } from '../resources/tourResource';
import { updateTourHandler } from '../resources/updateTourResource';
import vehicleDataResource from '../resources/vehicleDataResource';
import { VehicleIsolineResponse } from '../resources/vehicleIsolineResource';
import vehicleProfileDetails from '../resources/vehicleProfileDetailsResource';
import vehicleProfilesList from '../resources/vehicleProfileListResource';
import { vehiclesResource } from '../resources/vehiclesResource';

export const handlers = [
    subscriptionHandler({ SRP: true, eMSP: true }),
    sendToVehicleResponse.success,
    sendToOptimizerResponse.success,
    GetToursHandler,
    CreateTourHandler,
    UpdateTourHandler,
    updateTourHandler,
    chargingStationsMetadataResource.success,
    calculateItinerariesResource.success,
    selectItinerariesResource.success,
    vehiclesResource.success,
    vehicleDataResource,
    autosuggestHEREResource,
    VehicleIsolineResponse.success,
    TourIsolineResponse.success,
    assetSubscriptionResource,
    featureTogglesAllActive,
    operatorsListResource,
    chargingStationAutocomplete,
    chargingStationByIdResource,
    revgeocodeHEREResource,
    vehicleProfilesList,
    vehicleProfileDetails,
];
